import React from 'react';
import PropTypes from 'prop-types';

const ProductsHeader = React.forwardRef(function TableHeader({ tableWidth, products, cellWidth }, ref) {
    return (
        <div className="thead" ref={ref} style={{ width: tableWidth }}>
            <div className="mn-label-holder">&nbsp;</div>
            <div className="mn-cells-holder">
                <div className="cell" style={cellWidth}>
                    <div className="tilted">
                        <span>Select/Deselect all</span>
                    </div>
                </div>
                {products && products.length
                    ? products.map(item => (
                          <div className="cell" style={cellWidth} key={`prodHead${item.id}`}>
                              <div className="tilted">
                                  <span>
                                      {item.short_name} ({item.unit_abbreviation}, {item.contract_type})
                                  </span>
                              </div>
                          </div>
                      ))
                    : 'No products'}
            </div>
        </div>
    );
});

ProductsHeader.propTypes = {
    tableWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    cellWidth: PropTypes.shape({}).isRequired,
    products: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            short_name: PropTypes.string,
            unit_abbreviation: PropTypes.string,
            contract_type: PropTypes.string,
        }),
    ).isRequired,
};

export default React.memo(ProductsHeader);



// WEBPACK FOOTER //
// ./source/components/manageNotifications/tableHeader.js